import { makeStyles } from '@material-ui/core/styles';
import { ControlButton, Controls } from '@xyflow/react';
import { color } from '../../app/theme';
import icAdd from '../../assets/images/svg/ic_add_circle.svg';
import icFocus from '../../assets/images/svg/ic_focus.svg';
import icMinus from '../../assets/images/svg/ic_minus_circle.svg';

const useStyles = makeStyles(
  {
    root: {
      display: 'flex',
      alignItems: 'center',
      boxShadow: 'none',
      flexDirection: 'row !important',
      margin: '0 !important',
      bottom: '20px !important',
      left: '15px !important',
    },
    zoom: {
      width: 48,
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.38',
      letterSpacing: 'normal',
      cursor: 'pointer',
      color: color.$3,
      padding: '15px 7px',
      '&:hover': {
        background: '#f4f4f4',
      },
    },
    btn: {
      padding: 12,
      width: '48px !important',
      height: '48px !important',
      background: `${color.$7} !important`,
      border: 0,
    },
    left: {
      display: 'flex',
      alignItems: 'center',
      background: color.$7,
    },
  },
  {
    name: 'Controls',
  },
);

const FlowControls = ({ zoom = 1, instance }) => {
  const classes = useStyles();

  if (!instance) {
    return null;
  }

  return (
    <>
      <Controls
        className={classes.root}
        showZoom={false}
        showFitView={false}
        showInteractive={false}
      >
        <div className={classes.left}>
          <ControlButton
            className={classes.btn}
            onClick={() => instance.zoomTo(zoom - 0.2)}
          >
            <img src={icMinus} alt="minus-zoom" />
          </ControlButton>
          <div
            className={classes.zoom}
            onClick={() => instance.zoomTo(1)}
          >{`${parseInt(zoom * 100, 10)}%`}</div>
          <ControlButton
            className={classes.btn}
            onClick={() => instance.zoomTo(zoom + 0.2)}
          >
            <img src={icAdd} alt="add-zoom" />
          </ControlButton>
        </div>
        <ControlButton
          className={classes.btn}
          style={{ marginLeft: 8 }}
          onClick={() => instance.fitView()}
        >
          <img src={icFocus} alt="focus-zoom" />
        </ControlButton>
      </Controls>
    </>
  );
};

export default FlowControls;
